import About from '../views/About.vue'
import ContactUs from '../views/ContactUs.vue'
import FAQ from '../views/FAQ.vue'
import Home from '../views/Home.vue'
import SignUp from '../views/SignUp.vue'
import BlueChallenge from '../views/BlueChallenge.vue'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

Vue.use(VueRouter)
  const routes: Array<RouteConfig> = [
  { path: '/', name: 'Home', component: Home },
  { path: '/about', name: 'About', component: About },
  { path: '/contactus', name: 'Contact Us', component: ContactUs },
  { path: '/signup', name: 'Sign Up', component: SignUp },
  { path: '/bluechallenge', name: 'The BLUE Challenge', component: BlueChallenge },
  { path: '/faq', name: 'FAQ', component: FAQ },
  { path: '*', redirect: '/' }
]
//component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(/*to, from, savedPosition*/) {
    return { x: 0, y: 0 }
  }
})

export default router